// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-slider-component/theme/default.css
// module id = 415
// module chunks = 1